import React, { useState } from 'react'
import { Row, Col, Button, Typography } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from '../RegisterFootPrint.module.scss'
import Link from 'next/link'
import Calculators from './calculators/Calculators'

const { Text } = Typography

const RegisterFootPrintButtonsContent = () => {
  const { t } = useTranslation()
  const [showCalculator, setShowCalculator] = useState<boolean>(false)
  const closeModal = () => setShowCalculator(false)
  const openModal = () => setShowCalculator(true)

  return (
    <div className={styles['buttons-margin']}>
      <Row>
        <Col
          xs={24}
          md={11}
        >
          <Button
            type='primary'
            size='large'
            shape='round'
            className='radius-100'
            onClick={openModal}
            block
          >
            {t('footPrint.CalculateButton')}
          </Button>
        </Col>
        <Col span={2}></Col>
        <Col
          xs={24}
          md={11}
        >
          <Link href={'/my-footprint/list'}>
            <Button
              type='default'
              size='large'
              shape='round'
              className={`${styles['registration-button']} radius-100`}
              block
            >
              <Text className='text-color-primary'>
                {t('footPrint.MyRegistration')}
              </Text>
            </Button>
          </Link>
        </Col>
      </Row>

      <Calculators
        open={showCalculator}
        onClose={closeModal}
      />
    </div>
  )
}

export default RegisterFootPrintButtonsContent
